import {
  getCarHouseInvoices,
  editCarHouseInvoices,
  getCarHouseInvoicesItems,
  getUserInvoices,
  editUserInvoices,
  getUserInvoicesItems,
} from '../../lib/invoices';
import { createAsyncThunk } from '@reduxjs/toolkit';


export const fetchCarHouseInvoices = createAsyncThunk('invoices/fetchCarHouseInvoices', async (carHouseId) => {
  const data = await getCarHouseInvoices(carHouseId);

  return data;
});

export const payCarHouseInvoices = createAsyncThunk(
  'invoices/payCarHouseInvoices',
  async ({ carHouseId, invoiceId, body }, { rejectWithValue }) => {
    try {
      const response = await editCarHouseInvoices(carHouseId, invoiceId, body);

      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchCarHouseInvoicesItems = createAsyncThunk(
  'invoices/fetchCarHouseInvoicesItems',
  async ({carHouseId, invoiceId, pagination}) => {
    const data = await getCarHouseInvoicesItems(carHouseId, invoiceId, pagination);
    return data;
  }
);

export const fetchUserInvoices = createAsyncThunk(
  'invoices/fetchUserInvoices',
  async (userId) => {
    const data = await getUserInvoices(userId);
    return data;
  }
);

export const payUserInvoices = createAsyncThunk(
  'invoices/payUserInvoices',
  async ({ userId, invoiceId, body }, { rejectWithValue }) => {
    try {
      const response = await editUserInvoices(userId, invoiceId, body);
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchUserInvoicesItems = createAsyncThunk(
  'invoices/fetchUserInvoicesItems',
  async ({ userId, invoiceId, pagination}) => {
    const data = await getUserInvoicesItems(userId, invoiceId, pagination);
    return data;
  }
);